import { render, staticRenderFns } from "./CanalPagoCombobox.vue?vue&type=template&id=bf743f2c&scoped=true"
import script from "./CanalPagoCombobox.vue?vue&type=script&lang=js"
export * from "./CanalPagoCombobox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf743f2c",
  null
  
)

export default component.exports